import { ContentCard } from 'ui/components/2-molecules/Card/ContentCard';

export const ContentCardFeature: React.FC<Umbraco.ContentCard> = ({ content }) => {
	return <ContentCard {...content?.properties} />;
};
